import { Form, Pagination } from "react-bootstrap";

export default function NavigationCursorPagination({
    nextCursor,
    prevCursor,
    setCursor,
    perPage,
    setPerPage
}: {
    nextCursor: string | null,
    prevCursor: string | null,
    setCursor: (cursor: string | null) => void,
    perPage: number,
    setPerPage: (perPage: number) => void
}) {
    return (
        <nav className="list-pagination">
            <div className="pagination-actions">
                {prevCursor && (
                    <Pagination.Prev as="a" className="btn btn-prev" title="Précédent" onClick={() => setCursor(prevCursor)}>
                        <span className="icon"></span>
                        <span className="text">Précédent</span>
                    </Pagination.Prev>
                )}
                {nextCursor && (
                    <Pagination.Next as="a" className="btn btn-next" title="Suivant" onClick={() => setCursor(nextCursor)}>
                        <span className="icon"></span>
                        <span className="text">Suivant</span>
                    </Pagination.Next>
                )}
            </div>
            <div className="pagination-parameters">
                <Form.Group className="form-group">
                    <Form.Label className="form-label">Nb. par page</Form.Label>
                    <Form.Select className="form-select" id="pagination-parameters-itemsPerPage-select" value={perPage} onChange={(e) => setPerPage(Number(e.target.value))}>
                        <option value={10}>10</option>
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                    </Form.Select>
                </Form.Group>
            </div>
        </nav>
    );
}
